import { createContext, useContext } from 'react'

import sanitizer from '../../../helpers/sanitizer'
import { useAuth } from '../../Shared/Contexts/AuthContext'

const EventsContext = createContext({})

export const useEvents = () => {
  return useContext(EventsContext)
}

export const EventsProvider = ({ children }) => {
  const { useBaseAxiosPost, useBaseAxiosGet } = useAuth()

  const useSearchEvents = async ({ payload, page, pageSize }) => {
    return await useBaseAxiosPost({
      url: `/events/search?page=${page}&pageSize=${pageSize}`,
      payload: sanitizer(payload),
      project: ({ data, isSuccess, isError, status }) => ({
        data: data.results,
        count: data.totalCount,
        isSuccess: isSuccess,
        isError: isError,
        status: status
      })
    })
  }

  const useFetchEvents = async ({ deviceId, from, page, pageSize, to }) => {
    return await useBaseAxiosGet({
      url: '/events',
      params: {
        from,
        page,
        pageSize,
        to,
        deviceId
      }
    })
  }

  const useFetchEventsSearchSummary = async (filters) => {
    return await useBaseAxiosPost({
      url: '/events/search/summary',
      payload: sanitizer(filters),
      project: ({ data }) => data
    })
  }

  const value = {
    useSearchEvents,
    useFetchEvents,
    useFetchEventsSearchSummary
  }

  return <EventsContext.Provider value={value}>{children}</EventsContext.Provider>
}
